// extracted by mini-css-extract-plugin
export default {"close":"style_close__XELRd"};